@for (workInstruction of store.rows(); track workInstruction.id; let index = $index) {
  <div class="row pt-1 pb-1 mb-2 linked-items">
    <div class="col-12 col-md min-w-0 d-flex align-items-center gap-1">
      <span class="f-14 fw-600 work-instruction-order">{{ index + 1 }}</span>
      <span class="d-flex align-items-center work-instruction-name" (click)="onClickedOpenStepper(workInstruction.id)">
        <button
          mat-mini-fab
          class="me-xl-2 v-middle"
          type="button"
          matTooltip="{{ 'workInstructionStepper.button.startWorkInstruction' | translate }}"
        >
          <mat-icon>play_circle_outline</mat-icon>
        </button>
        <a class="cursor-pointer link text-truncate" [matTooltip]="workInstruction.name">
          {{ workInstruction.name }}
        </a>
      </span>
    </div>
    <div class="col-12 col-md-auto d-flex align-items-center gap-1">
      @if (workInstruction.workInstructionStatus.isLate) {
        <app-status-category-badge
          [statusCategory]="EStatusBadgeExtraCategory.late"
          [label]="'workInstructionStepper.status.late' | translate"
        ></app-status-category-badge>
      }
      <app-status-category-badge
        [statusCategory]="workInstruction.workInstructionStatus.statusCategory"
        [label]="'workInstructionStepper.status.' + workInstruction.workInstructionStatus.status | translate"
      ></app-status-category-badge>
      <span class="f-12 fw-600 step-count">
        {{ workInstruction.workInstructionStatus.completedStepCount }} /
        {{ workInstruction.workInstructionStatus.totalStepCount }}
      </span>
      <mat-progress-bar
        class="step-progress-bar"
        mode="determinate"
        [value]="workInstruction.workInstructionStatus.percentage"
        [matTooltip]="workInstruction.workInstructionStatus.percentage + '%'"
      ></mat-progress-bar>
    </div>
    <div class="col-12 col-md-auto d-flex align-items-center justify-content-end">
      @if (workInstruction.assignmentId) {
        <button
          class="check-in-count-chip me-xl-2"
          type="button"
          (click)="openCheckInDialog(workInstruction)"
          matTooltip="{{ 'workInstruction.checkIn.checkedInUsers' | translate }}"
        >
          <mat-icon>person</mat-icon>
          <span>{{ workInstruction.checkIns.length }}</span>
        </button>
      }
      <button
        mat-mini-fab
        class="me-xl-2 v-middle remove-button"
        (click)="openWorkInstructionHistory(workInstruction.id)"
        matTooltip="{{ 'field.workInstructionHistory' | translate }}"
        type="button"
      >
        <mat-icon>history</mat-icon>
      </button>
      @if (workInstruction.assignmentId) {
        <button
          mat-mini-fab
          class="me-xl-2 v-middle remove-button"
          type="button"
          (click)="openCheckInDialog(workInstruction)"
          matTooltip="{{ 'button.checkIn' | translate }}"
        >
          <mat-icon>how_to_reg</mat-icon>
        </button>
      }
      <button
        mat-mini-fab
        class="me-xl-2 v-middle remove-button"
        (click)="onRemoveLinkClick(workInstruction)"
        matTooltip="{{ 'button.remove' | translate }}"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}
